var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c("div", { staticClass: "panel-tag" }, [
        _vm._v("\n        " + _vm._s(_vm.__t("SEND_INFO")) + "\n    "),
      ]),
      _vm._v(" "),
      _c("b-overlay", { attrs: { show: _vm.is_active, rounded: "sm" } }, [
        _c(
          "button",
          {
            staticClass: "btn btn-lg waves-effect waves-themed",
            class: [
              _vm.is_active ? "btn-outline-warning" : "btn-outline-success",
            ],
            attrs: { type: "button", disabled: _vm.is_active },
            on: { click: _vm.send_order },
          },
          [
            _c("span", {
              staticClass: "fal mr-1",
              class: [
                _vm.is_active ? "fa-exclamation-triangle" : "fa-download",
              ],
            }),
            _vm._v(
              "\n            " + _vm._s(_vm.__t("MANUAL_SEND")) + "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass:
              "btn btn-lg waves-effect waves-themed btn-outline-warning",
            attrs: { type: "button", disabled: _vm.is_print },
            on: { click: _vm.print_order },
          },
          [
            _c("span", {
              staticClass: "fal mr-1",
              class: [_vm.is_print ? "fa-exclamation-triangle" : "fa-download"],
            }),
            _vm._v(
              "\n            " + _vm._s(_vm.__t("PRINT_ORDER")) + "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _vm.is_syrve
          ? _c(
              "button",
              {
                staticClass: "btn btn-lg waves-effect waves-themed",
                class: [
                  _vm.is_check_work
                    ? "btn-outline-warning"
                    : "btn-outline-warning",
                ],
                attrs: { type: "button", disabled: _vm.is_check_work },
                on: { click: _vm.check_order },
              },
              [
                _c("span", {
                  staticClass: "fal mr-1",
                  class: [
                    _vm.is_check_work
                      ? "fa-exclamation-triangle"
                      : "fa-download",
                  ],
                }),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.__t("CHECK_STATUS")) +
                    "\n        "
                ),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "logs_data" },
        [
          _vm.order_logs.length > 0
            ? _c("order_logs", {
                attrs: { logs: _vm.order_logs, cur_provider: _vm.pos_provider },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }